import { MI_NODES } from '~/widgets/CostBomDemo/assets/generated/miNodes'
import { PANELS_HTML } from '~/widgets/CostBomDemo/assets/generated/panelsHtml'
import { SKELETON_HTML } from '~/widgets/CostBomDemo/assets/generated/skeletonHtml'
import { initHeroSampleBreakdown } from '~/widgets/CostBomDemo/source/hero-sample/breakdown'
import { initHeroSampleFormat } from '~/widgets/CostBomDemo/source/hero-sample/format'
import { initHeroSampleIdle } from '~/widgets/CostBomDemo/source/hero-sample/idle'
import { initHeroSampleInit } from '~/widgets/CostBomDemo/source/hero-sample/init'

let panelsReady = false
let panelsLoading: Promise<void> | null = null

function ensurePanelsReady(root: HTMLElement): Promise<void> {
  if (panelsReady) return Promise.resolve()
  if (panelsLoading) return panelsLoading

  panelsLoading = new Promise((resolve) => {
    const sampleRoot = root.querySelector('#hero-sample-root')
    if (!sampleRoot) {
      resolve()
      return
    }

    const wrap = document.createElement('div')
    wrap.innerHTML = PANELS_HTML
    while (wrap.firstChild) sampleRoot.appendChild(wrap.firstChild)

    initHeroSampleFormat()
    initHeroSampleBreakdown()
    initHeroSampleInit()

    panelsReady = true
    window.heroPanelsReady = true
    resolve()
  })

  return panelsLoading
}

export function mountBomPanels(root: HTMLElement) {
  window.MI_NODES = MI_NODES

  const sampleRoot = root.querySelector('#hero-sample-root')
  if (!sampleRoot) return

  sampleRoot.innerHTML = SKELETON_HTML
  initHeroSampleIdle()

  const sampleMap: Record<string, string> = {
    'NMC Battery Cell': 'nmc',
    'Citric Acid': 'citric',
    'Smart Home SoC': 'soc',
  }

  window.heroGenerateSample = (key?: string) => {
    const pin = root.querySelector<HTMLInputElement>('#hero-dd-product')
    const sampleKey =
      key || sampleMap[pin?.value || 'NMC Battery Cell'] || 'nmc'
    return ensurePanelsReady(root).then(() => {
      if (window.heroShowSample) window.heroShowSample(sampleKey)
    })
  }

  window.heroShowIdle = () => {
    if (window.heroShowSample) window.heroShowSample('idle')
  }
}

declare global {
  interface Window {
    MI_NODES?: Record<
      string,
      {
        name: string
        cost: number
        mass: number
        profile: string
        sources: Array<{ n: string; p: number }>
        rootCost: number
        breakdown?: Record<string, number>
      }
    >
    heroPanelsReady?: boolean
    heroGenerateSample?: (key?: string) => Promise<void>
    heroShowIdle?: () => void
    heroShowSample?: (key: string) => void
    heroStartGenerate?: () => void
    cm2BuildTab?: (product: string, country: string) => void
    closeHeroTabAddPop?: () => void
    setHeroProductImage?: (product: string) => void
  }
}
